<template>
  <div ref="el" class="k2-pop" :class="'k2-pop--' + kind" :role="role" :aria-label="label" :style="style">
    <slot />
  </div>
</template>

<script>
// Iskakanje uz dugme (meni kartice, period, restoran). Postavlja se iznad ili ispod dugmeta tako da stane u ekran,
// zatvara se dodirom izvan sebe, a prvo dugme u njemu dobija fokus. Escape i povratak fokusa rješava stranica.
export default {
  name: "Kds2Pop",
  props: {
    anchor: { default: null }, // element dugmeta
    kind: { type: String, default: "menu" },
    label: { type: String, default: "" },
    role: { type: String, default: "dialog" },
    above: { type: Boolean, default: false }, // meni kartice se otvara iznad dugmeta
  },
  data() {
    return { style: { visibility: "hidden", left: "0px", top: "0px" } };
  },
  mounted() {
    this.place();
    document.addEventListener("pointerdown", this.onOutside, true);
    window.addEventListener("resize", this.place);
    // fokus tek kad je iskakanje vidljivo (prije prvog postavljanja ima visibility: hidden)
    this.$nextTick(() => {
      const first = this.$el && this.$el.querySelector("button, input");
      if (first) first.focus({ preventScroll: true });
    });
  },
  updated() {
    this.place();
  },
  beforeDestroy() {
    document.removeEventListener("pointerdown", this.onOutside, true);
    window.removeEventListener("resize", this.place);
  },
  methods: {
    place() {
      const el = this.$el;
      const a = this.anchor && this.anchor.isConnected ? this.anchor.getBoundingClientRect() : null;
      if (!el || !a) {
        if (!a) this.$emit("close");
        return;
      }
      const pw = el.offsetWidth;
      const ph = el.offsetHeight;
      const vw = window.innerWidth;
      const vh = window.innerHeight;
      const left = Math.min(Math.max(8, a.left), Math.max(8, vw - pw - 8));
      let top = this.above ? a.top - ph - 6 : a.bottom + 6;
      if (this.above && top < 8) top = Math.min(vh - ph - 8, a.bottom + 6);
      else if (!this.above && top + ph > vh - 8) top = Math.max(8, a.top - ph - 6);
      const next = { visibility: "visible", left: left + "px", top: top + "px" };
      if (next.left !== this.style.left || next.top !== this.style.top || this.style.visibility !== "visible") this.style = next;
    },
    onOutside(e) {
      if (this.$el.contains(e.target)) return;
      if (this.anchor && this.anchor.contains && this.anchor.contains(e.target)) return;
      this.$emit("close");
    },
  },
};
</script>
